import cx from 'classnames';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import s from './RegisterPage.module.scss';

import Register from 'components/register/register';
import { Button } from 'components/ui/Button';
import { useAuth } from '../../hooks';

import { CheckClientModal } from 'components/modal/checkClient';
import { AppRoutes } from 'config/routes';
import { useSelector } from 'react-redux';
import { selectCurrentCertificate } from 'store/reducers/certificates';
import { message } from 'antd';
import { ArrowRight as ArrowRightIcon } from 'components/icons';

export function RegisterPage() {
  const isToken = useAuth();
  const { t } = useTranslation();

  const { Home, Infopanel, Contracts } = AppRoutes.Dashboard;
  const currentCertificate = useSelector(selectCurrentCertificate());

  const navigate = useNavigate();

  function handleSubmitClick() {
    if (!currentCertificate) {
      message.error(t('Select the certificate to sign in'));
      return;
    }
    navigate(`${AppRoutes.Auth.Home}${AppRoutes.Auth.Offer}`);
  }

  useEffect(() => {
    if (isToken) {
      navigate(Home + (Infopanel || Contracts.Home));
    }
  }, [isToken, navigate]);

  return (
    <div className={s.root}>
      <div className={s.content}>
        <div className={s.firstBlock}>
          <div className={s.header}>
            {t('Connects')} <br /> {t('Business')}
          </div>

          <h1 className={s.title}>{t('Registration')}</h1>
        </div>

        <div className={s.secondBlock}>
          <StepIndicator step={1} />

          <Register />
        </div>
      </div>

      <div className={s.bottom}>
        <Button
          
          className={s.button}
          onClick={handleSubmitClick}
          disabled={!currentCertificate}
        >
          {t('Next')}
        </Button>
      </div>

      <CheckClientModal isCertificate={true} />
    </div>
  );
}

export function StepIndicator(props: { step?: number; steps?: number }) {
  const { step = 1, steps = 3 } = props;

  return (
    <div className={s.stepIndicator}>
      {[...Array(steps)].map((_, i) => (
        <span key={i} className={cx(s.step, { [s.stepFilled]: step > i })}>
          {i > 0 && <ArrowRightIcon />}
          <span>{i + 1}</span>
        </span>
      ))}
    </div>
  );
}
